<mat-toolbar class="page-header">
  <div class="menu-container">
    <button backPage class="pg-header-btn" mat-icon-button>
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="pg-title">Add New Partner</div>
    <span fxFlex></span>
  </div>
</mat-toolbar>

<div [formGroup]="form" class="content-container">
  <div class="pb-sm" fxLayoutAlign="end center">
    <button
      (click)="savePartner()"
      [disabled]="form.invalid"
      color="primary"
      mat-flat-button
    >
      Save
    </button>
  </div>

  <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="32px">
    <div fxLayout="column" fxLayoutGap="32px" style="flex: 1; min-width: 0">
      <mat-card id="partner-details">
        <div class="title-f">Partner Details</div>

        <mat-form-field style="width: 100%">
          <mat-label>Partner / Company Name</mat-label>
          <input formControlName="name" matInput />
          <mat-error *ngIf="form.get('name').hasError('required')">
            Partner / Company Name is required.
          </mat-error>
        </mat-form-field>

        <div fxLayout="row" fxLayoutGap="16px">
          <mat-form-field style="width: 50%">
            <mat-label>Industry Sector</mat-label>
            <mat-select formControlName="industrySector">
              <mat-option
                *ngFor="let item of industrySectors"
                [value]="item.id"
              >
                {{ item.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('industrySector').hasError('required')">
              Industry Sector is required.
            </mat-error>
          </mat-form-field>
          <mat-form-field style="width: 50%">
            <mat-label>Sub Sector</mat-label>
            <mat-select formControlName="subSector">
              <mat-option *ngFor="let item of subSectors" [value]="item.id">
                {{ item.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('subSector').hasError('required')">
              Sub Sector is required.
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field style="width: 100%">
          <mat-label>Company Registration No.</mat-label>
          <input formControlName="registrationNo" matInput />
          <mat-error *ngIf="form.get('registrationNo').hasError('required')">
            Company Registration No. is required.
          </mat-error>
        </mat-form-field>

        <div class="fs-md fw-semi-b">Company Documents</div>
        <div style="color: #7092bb; font-size: 12px">
          Upload SSM document, supporting document or agreement document.
        </div>
        <div style="width: 60%">
          <app-resizable-upload
            [accept]="'.png,.jpg,.jpeg,.pdf'"
            [maxSize]="5"
            [multiple]="true"
            [requireCropping]="false"
            formControlName="documents"
          ></app-resizable-upload>
          <mat-error
            *ngIf="
              form.get('documents').invalid &&
              (form.get('documents').touched || form.get('documents').dirty) &&
              form.get('documents').hasError('required')
            "
          >
            Company document is required.
          </mat-error>
          <mat-error
            *ngIf="
              form.get('documents').invalid &&
              (form.get('documents').touched || form.get('documents').dirty) &&
              form.get('documents').hasError('fileSize')
            "
          >
            File size cannot exceed 5MB.
          </mat-error>
        </div>
      </mat-card>

      <mat-card id="partner-branding">
        <div class="title-f mb-md">Partner's Branding</div>

        <div fxLayout="row" fxLayoutGap="16px">
          <mat-form-field
            class="floating-label-prefix"
            floatLabel="always"
            style="width: 70%"
          >
            <mat-label>Partner's Portal URL</mat-label>
            <input formControlName="urlSlug" mask="A*" matInput />
            <span matPrefix style="color: #7092bb"
              >{{ environment.o2o }}/&nbsp;</span
            >
            <mat-error *ngIf="form.get('urlSlug').hasError('required')"
              >Portal URL is required.</mat-error
            >
            <mat-error *ngIf="form.get('urlSlug').hasError('pattern')"
              >Only alphanumeric characters are allowed.</mat-error
            >
          </mat-form-field>

          <mat-form-field style="width: 30%">
            <mat-label>Portal Theme Color</mat-label>
            <input
              [mtxColorpicker]="picker"
              formControlName="themeColor"
              matInput
            />
            <mtx-colorpicker-toggle
              [for]="picker"
              matSuffix
            ></mtx-colorpicker-toggle>
            <mtx-colorpicker #picker></mtx-colorpicker>
            <mat-error *ngIf="form.get('themeColor').hasError('required')"
              >Portal theme color is required.</mat-error
            >
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="16px">
          <div style="width: 50%">
            <div class="fs-md fw-semi-b mt-md">Company Logo</div>
            <div>
              <app-resizable-upload
                      [aspectRatio]="7"
                      [maxSize]="5"
                formControlName="logo"
              ></app-resizable-upload>
              <mat-error
                *ngIf="
                  form.get('logo').invalid &&
                  (form.get('logo').touched || form.get('logo').dirty) &&
                  form.get('logo').hasError('required')
                "
              >
                Company logo is required.
              </mat-error>
              <mat-error
                *ngIf="
                  form.get('logo').invalid &&
                  (form.get('logo').touched || form.get('logo').dirty) &&
                  form.get('logo').hasError('fileSize')
                "
              >
                File size cannot exceed 5MB.
              </mat-error>
            </div>
          </div>
          <div style="width: 50%">
            <div class="fs-md fw-semi-b mt-md">Banner Image</div>
            <div>
              <app-resizable-upload
                      [aspectRatio]="1"
                      [maxSize]="5"
                formControlName="banner"
              ></app-resizable-upload>
              <mat-error
                *ngIf="
                  form.get('banner').invalid &&
                  (form.get('banner').touched || form.get('banner').dirty) &&
                  form.get('banner').hasError('required')
                "
              >
                Banner image is required.
              </mat-error>
              <mat-error
                *ngIf="
                  form.get('banner').invalid &&
                  (form.get('banner').touched || form.get('banner').dirty) &&
                  form.get('banner').hasError('fileSize')
                "
              >
                File size cannot exceed 5MB.
              </mat-error>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="sidebar-container">
      <app-partner-navigation-sidebar [sections]="sections"></app-partner-navigation-sidebar>
    </div>
  </div>
</div>
